import React from 'react';
import { Controller } from 'react-hook-form';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

const ContactDropdownField = ({ name, control, options, placeholder, onChange, disabled, getFormErrorMessage, rules = {} }) => {
  return (
    <div className="d-flex align-items-center py-2 flex-wrap">
      <div className="col-12 col-lg-4 p-medium">
        {placeholder}
        {rules.required && <label className="text-danger">*</label>}
      </div>
      <div className="col-12 col-lg-8">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <div className="d-flex">
              <Dropdown
                {...field}
                className="input-shadow w-100 border-0"
                options={options}
                placeholder={placeholder}
                onChange={(e) => {
                  field.onChange(e.value);
                  if (onChange) onChange(e.value);
                }}
                value={field.value}
                disabled={field.value && disabled}
                focusInputRef={field.ref}
              />
              {!rules.required && field.value && !disabled && (
                <Button
                  type="button"
                  icon="pi pi-times"
                  className="p-button-text p-button-danger p-ml-2"
                  onClick={(e) => {
                    e.preventDefault();
                    field.onChange('');
                  }}
                  aria-label="Clear"
                />
              )}
            </div>
          )}
        />
      </div>
      {getFormErrorMessage(name)}
    </div>
  );
};

export default ContactDropdownField;
